export enum ContractFinanceStatus {
  CASH = "Cash Buyer",
  PRE_APPROVED = "Pre-approved",
  PENDING = "Pending",
}
